export const iconFontAwesomeHumanitarianChurch = (
	<i className="fa-solid fa-church"></i>
);
